<template>
  <section class="founder-section" id="about">
    <div class="container">
      <div class="section-shell">
        <div>
          <span class="subtitle">Profil</span>
          <h2>Jens Trompler verbindet <span class="text-gradient">Beratung, Umsetzung und technisches Verständnis</span>.</h2>
        </div>
        <div class="founder-copy">
          <p>
            Hinter den einzelnen Bereichen steht praktische Erfahrung aus Projekten, Betrieb und technischer Umsetzung. Dadurch geht es hier nicht nur um Konzepte, sondern um Themen, die im Alltag funktionieren müssen.
          </p>
          <p>
            Für Kunden soll die Seite vor allem eins leisten: schnell zeigen, welcher Bereich zum eigenen Thema passt.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FounderSection'
};
</script>

<style lang="scss" scoped>
@use "@/assets/css/global.scss" as *;

.founder-section {
  background: linear-gradient(180deg, #f2f6fa, rgba($accent-teal, 0.02));
}

.section-shell {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 2rem;
  align-items: start;
}

.founder-copy {
  padding: 1.75rem;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid $line-color;
  box-shadow: $shadow-md;
}

.founder-copy p:last-child {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .section-shell {
    grid-template-columns: 1fr;
  }
}
</style>
